import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared';

import { TaskFeasibilityInfoComponent } from './task-feasibility-info.component';

@NgModule({
    imports: [CommonModule, SharedModule],
    exports: [TaskFeasibilityInfoComponent],
    declarations: [TaskFeasibilityInfoComponent]
})
export class TaskFeasibilityInfoModule {}
